/* eslint class-methods-use-this: 0 */
import CollectionApi from 'client/api/v2/CollectionApi';

export default class BaseApplicationApi extends CollectionApi {
  setSearchTerm(params, searchTerm) {
    if (searchTerm !== '') {
      if (params) {
        // eslint-disable-next-line no-param-reassign
        params.search = searchTerm;
      }
    } else if (params) {
      // eslint-disable-next-line no-param-reassign
      delete params.search;
    }
  }
}
